<template>
    <div class="tabs-segment-wrapper" :class="[tabSize]">
        <div
        v-for="tab in tabsList"
        class="tab"
        :key="tab.id"
        :class="[{ 'selected': tab.selected, 'mobile': getMobileAppState }, tab.state]"
        @click="emit('clicked', tab.id)">{{tab.label}}</div>
    </div>
</template>

<script setup>
/* Store & mapGetters */
import { mapGetters } from '@/store/helpers/mappers'
const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['clicked'])

/** props received
@tabsList {Array} in which each object has:
	- id { String, Number }
	- label { String }
	- selected { Boolean }
@tabSize {String} can be [medium (default), small]
*/
const props = defineProps({
	tabsList: Array,
    tabSize: String
})
</script>

<style lang="scss" scoped>
.tabs-segment-wrapper {
    width: fit-content;
    height: 48px;
    padding: 4px;

    display: flex;

    border-radius: 10px;
    border: 1px solid var(--secondary-light-2);
    background: var(--secondary-light-4);

    .tab {
        width: auto;
        height: 100%;
        padding: 0 16px;

        @include H7-Medium;
        line-height: 40px;
        color: var(--secondary-dark-3);
        text-align: center;

        cursor: pointer;
        border-radius: 8px;

        &.selected {
            color: var(--primary);
            background-color: var(--primary-light-3);
        }

        @media only screen and (max-width: 360px) {
            padding: 0 8px;
        }

        @media (hover: hover) and (pointer: fine) {
            &:not(.mobile) {
                &:hover {
                    background-color: var(--secondary-light-3);
                }

                &:focus {
                    background-color: var(--secondary-light-2);
                }
            }
        }
    }

    &.small {
        height: 40px;

        .tab {
            height: 100%;
            line-height: 32px;
        }
    }
}
</style>
